module.exports = __webpack_public_path__ + "img/facebook-white.08b9787a.svg";